import { useState } from "react";
import { Typography, Popper, Box, Card, Stack, Avatar } from "@mui/material";
import sampleProfileImage from "assets/images/sample.png";

const UserTag = ({ userTag }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={{
          backgroundColor: "rgba(74, 74, 117, 0.5)",
          padding: "0 0.25rem",
          borderRadius: "0.25rem",
          cursor: "pointer",
          display: "inline-flex",
        }}
      >
        @{userTag.name || "Unknown User"}
      </Box>

      <Popper open={open} anchorEl={anchorEl} placement="top">
        <Box sx={{ pb: "0.5rem" }}>
          <Card
            sx={{
              p: 2,
              backgroundColor: "#19191b",
              border: "1px solid #333",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              maxWidth: "500px",
              maxHeight: "120px",
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
              <Avatar
                variant="circular"
                alt={userTag.name.toUpperCase()}
                src={userTag.profile_picture || sampleProfileImage}
                sx={{ width: "48px", height: "48px" }}
              />
              <Box>
                <Stack>
                  <Typography sx={{ fontSize: "1rem", color: "#ddd9d5", fontWeight: "700" }}>
                    {userTag.name}
                  </Typography>
                  {userTag.UserCompanyRole && (
                    <Typography sx={{ fontSize: "0.85rem", color: "#666" }}>
                      {userTag.UserCompanyRole.role_name}
                    </Typography>
                  )}
                  {userTag.user.email && (
                    <Typography sx={{ fontSize: "0.85rem", color: "#666" }}>
                      {userTag.user.email}
                    </Typography>
                  )}
                </Stack>
              </Box>
            </Stack>
          </Card>
        </Box>
      </Popper>
    </>
  );
};

export default UserTag;
